import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('mappingProgramProcessStore', Object.keys(state)),
	...mapGetters('mappingProgramProcessStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('mappingProgramProcessStore', Object.keys(actions)),
	...mapMutations('mappingProgramProcessStore', Object.keys(mutations))
};
